import api from '@/api'

export async function signIn(payload) {
  const response = await api.post('/v1/auth/sign-in', payload)
  return response.data
}

export async function getSnsAuthorizeUrl(providerType, redirectUri) {
  const response = await api.get(`/v1/auth/sns/${providerType}/authorize-url`, {
    params: { redirectUri }
  })
  return response.data
}

export async function snsCallback(providerType, payload) {
  const response = await api.post(`/v1/auth/sns/${providerType}/callback`, payload)
  return response.data
}

export async function logout(payload) {
  const response = await api.post('/v1/auth/logout', payload)
  return response.data
}

export async function checkEmailAvailability(email) {
  const response = await api.get('/v1/auth/sign-up/email-availability', {
    params: { email }
  })
  return response.data
}

export async function signUp(payload) {
  const response = await api.post('/v1/auth/sign-up', payload)
  return response.data
}

export async function fetchMe() {
  const response = await api.get('/v1/auth/me')
  return response.data
}

export async function updateMyInfo(payload) {
  const response = await api.post('/v1/auth/me/update', payload)
  return response.data
}

export async function updateRecommendedBranch(payload) {
  const response = await api.post('/v1/auth/me/recommended-branch', payload)
  return response.data
}

export async function setPaymentPassword(payload) {
  const response = await api.post('/v1/auth/payment-password/set', payload)
  return response.data
}

export async function verifyPaymentPassword(payload) {
  const response = await api.post('/v1/auth/payment-password/verify', payload)
  return response.data
}

/** 결제 비밀번호 재설정 - 본인인증(purpose reset-payment-password) 뒤 10분 안에만 된다 */
export async function resetPaymentPassword(payload) {
  const response = await api.post('/v1/auth/payment-password/reset', payload)
  return response.data
}

export async function changePaymentPassword(payload) {
  const response = await api.post('/v1/auth/payment-password/change', payload)
  return response.data
}

/**
 * 본인인증(NICE) — 공용 서버를 거친다. 2026-11-01 에 가짜(mock-complete)를 걷어냈다.
 *   start    → { startUrl } : 같은 창으로 연다(앱 WebView 에서 팝업이 안 열린다)
 *   complete → /auth/verify/done 이 돌려받은 identityToken · state 를 넘긴다
 *   merge    → 같은 사람으로 이미 인증된 계정이 있을 때, 확인을 받고 그쪽으로 합친다
 */
export async function startIdentityVerification(payload) {
  const response = await api.post('/v1/auth/verify/start', payload || {})
  return response.data
}

export async function completeIdentityVerification(payload) {
  const response = await api.post('/v1/auth/verify/complete', payload || {})
  return response.data
}

export async function mergeIdentityVerification(payload) {
  const response = await api.post('/v1/auth/verify/merge', payload || {})
  return response.data
}
